(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["copy-code-button"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
    // The button, or the code text right before it.
    const button =
      event.target.closest('[data-copy-code]') ??
      (event.target.nextElementSibling?.matches('[data-copy-code]') ? event.target.nextElementSibling : null);
    if (!button) return;
    event.preventDefault();

    let text = button.previousElementSibling?.textContent.trim();
    if (!text) return;
    // "10468-10" -> "10468": the part after the last dash is the DGE sales unit.
    if (button.dataset.copyCode === 'strip-sales-unit') {
      text = text.replace(/^(\d+)-\d+$/, '$1');
    }

    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.error('Copy failed:', error);
      return;
    }

    button.classList.add('is-copied');
    button.querySelector('[data-copy-code-status]').textContent = 'Gekopieerd';
    clearTimeout(button.copyCodeTimer);
    button.copyCodeTimer = setTimeout(() => {
      button.classList.remove('is-copied');
      button.querySelector('[data-copy-code-status]').textContent = '';
    }, 2000);
  });
  } catch(e) { console.error(e); }
})();

})();
